import Model from '@/models/Model'

export default class AReceive extends Model {
    resource() {
        return 'receive'
    }
}